export const apiEndPoints = {
  api: `/api`,
  version1: `/v1`,
  itr: `/itr`,
  rrsp: `/rrsp`,
  deduction: `/deduction`,
  provincial: `/provincial`,
  pages: `/pages`,
  maritalStatus: `/marital-status`,
  itrMetaData: `/itr/meta-data`,
  businessDetails: '/business-details',
  businessRevenue: '/business-summary',
  businessExpense: '/business-expenses',
  naicsSubCategory: `/naics-sub-category`,
  completeItrProfile: `/profile`,
  mailingDetails: `/mailing-details`,
  backgroundDetails: `/background`,
  infoSummary: `/info`,
  accounts: `/accounts`,
  signUp: `/sign-up`,
  login: `/login`,
  logout: `/logout`,
  confirmOtp: `/confirm-otp`,
  resendOtp: `/resend-otp`,
  forgotPassword: `/forgot-password`,
  pricePlanSeen: `/screen-pref`,
  resetPassword: `/reset-password`,
  updatePassword: `/update-password`,
  t3TrustIncomeTax: `/t3trust-income-tax`,
  t4RifTax: `/t4rif-tax`,
  t4APension: `/t4a-tax`,
  t4PsIncome: `/t4ps-tax`,
  t4RspIncome: `/t4rsp-tax`,
  slipList: `/tax-form-data`,
  t5Investment: `/t5investment-income-tax`,
  t5008Securities: `/t5008security-transaction-tax`,
  t4AOasSecurities: `/t4a-oas`,
  t4eBenefits: `/t4e-benefits`,
  t5007Benefits: `/t5007`,
  rc62UCCB: `/rc62-uccb`,
  rc210Cwb: `/rc210-cwb`,
  t4ApCppQppBenefits: `/t4ap-cpp-qpp`,
  t4Enumeration: `/t4remuneration-tax`,
  t4arcaArrangement: `/t4a-rca-drc-arrangement`,
  T5006RegisteredLabour: `/t5006-registered-labour`,
  retirementSavingForm: `/rrsp-retirement-tax`,
  otherEmploymentIncome: `/tips-other-income`,
  employeeStatusData: `/employment-status-data`,
  businessCategory: `/self-employment-intro`,
  clergyResidenceDeduction: `/clergy-residence-deduction`,
  clergyResidenceDeduction2: `/clergy-residence-deduction-values`,
  wageLossReplacement: `/wage-loss-replacement-plan`,
  t2202Tuition: `/t2202_tuition_enrollment-tax`,
  employmentExpenses: `/other-employment-expense`,
  employmentStatusProfile: `/employment-status-intro`,
  additionalCppQpp: `/cpp-qpp-contributions-form`,
  gstRebate: `/gst_370_rebate_form`,
  transportEmployee: `/information-transport-employee`,
  shortHaul: `/short-haul-trip-details`,
  longHaul: `/long-haul-trip-details`,
  repayments: `/repayments-form`,
  deferredStock: `/deferred-stock-option-benefits`,
  employeeProfitSharing: `/profit-sharing-plan`,
  medicalSlip: `/medical-slip`,
  donationSlip: `/donation-slip`,
  myProfile: `/profile`,
  slipFormMetaData: `/tax-form-meta`,
  termsAndConditionsPage: `/terms`,
  privacyPolicyPage: `/privacy`,
  provincialInfoPage: `/provincial-info`,
  cai: `/climate-action-incentive`,
  homeownersPropertyTax: `/homeowners-property-tax`,
  selfEmploymentTax: `/self-employment-tax/`,
  provincialProfile: `/provincial-profile`,
  t101Slip: `/t101-resource-expenses`,
  t5013Slip: `/t5013-partnership-income`,
  t5013SlipIncomeSource: `/t5103-income-source`,
  t10PensionAdjustment: `/t10-pension-adjustment-reversal`,
  foreignIncome: `/foreign-income`,
  t1139Form: `/t1139-form`,
  workBusiness: `/apply-to-work`,
  partnershipDetails: `/partnership-details`,
  aboutPartnership: `/about-partnership`,
  expensesPartnership: `/expenses-for-partnership`,
  equityPartnership: `/details-of-equity`,
  businessIncome: `/professional-business-income`,
  personalVehicleExpenses: '/professional-vehicle-personal-expense',
  businessVehicleExpenses: '/professional-vehicle-business-expense',
  earnedIncomeWebsite: `/income-from-website`,
  advertising: `/advertising-expense`,
  entertainment: `/meal-entertainment-expense`,
  wages: `/wages-salaries-expense`,
  businessRelated: `/work-business-related-travel`,
  doubtfulAccount: `/doubtful-account`,
  licensesTaxes: `/pay-for-licenses`,
  commercialInsurance: `/pay-for-commercial-insurance`,
  interestMaintenance: `/pay-interest-maintenance`,
  selfBusinessIncome: `/professional-self-employment`,
  refundableCredit: `/refundable-credit`,
  csa: `/csa`,
  climateIncentive: '/climate-incentive',
  taxSummary: '/tax-summary',
  payment: '/payment',
  paymentCharge: '/charge',
  paymentDetail: '/payment-detail',
  reviewTaxSummary: '/review-tax-summary',
  admin: '/admin',
  dashboardTiles: '/dashboard-tiles',
  users: '/users',
  analytics: '/analytics',
  download: '/download',
  emailItr: '/email-detail',
  fileReturnCompleted: '/file',
  termsAndConditions: '/terms-and-conditions',
  afr: '/afr',
  initiate: '/initiate',
  available_tax_slip: '/available_tax_slip_for_auto_fill',
  craMyAccount: '/cra_my_account',
  dont_have_cra_account: '/dont_have_cra_account',
  craSignProblem: '/problems_signing_in',
  auto_fill_using_cra: '/auto_fill_using_cra_tnc',
  fetch_return_data: '/fetch-return-data',
  selfEmploymentData: '/self-employment-data',
  officeSupplies: '/pay-office-supplies',
  bankingFeesAdvice: `/pay-banking-fees`,
  taxesRent: `/pay-property-taxes`,
  utilitiesBusiness: `/pay-for-utilities`,
  otherExpenses: `/any-other-expenses`,
  uccBalances: `/ucc-balances`,
  additionDisposition: `/addition-disposition`,
  homeForWork: `/part-of-your-home`,
  homeUseForWork: `/home-use-for-work`,
  homeYouUseForWork: `/home-not-for-work`,
  homeExpenses: `/home-expenses`,
  selfEmploymentRevenue: `/self-employment-revenue`,
  reservesDeducted: `/reserves_deducted`,
  sellProductBought: `/sell-product-bought`,
  fishingData: `/fishing-data`,
  fishingIntro: `/fishing-intro`,
  fishingIncome: `/fishing-income`,
  otherFishingIncome: `/other-fishing-income`,
  fishingExpenses: `/fishing-expense`,
  otherFishingExpenses: `/other-fishing-expense`,
  otherDeductions: `/other-fishing-deduction`,
  fishingReconciliationForm: `/fishing-reconciliation`,
  fishingHomeForWork: `/fishing-home-expense`,
  farmingData: `/farming-summary-data`,
  farmingIntro: `/farming-intro`,
  farmingIncome: `/farming-income`,
  otherFarmingIncome: `/other-farming-income`,
  farmingLiveStockSold: `/farming-live-stock-sold`,
  farmingProgramPayment: `/farming-program-payment`,
  farmingExpenses: `/farming-live-stock-purchased`,
  farmingProgramOverpayment: `/farming-program-overpayment`,
  farmingExpensesLiveStock: `/farming-expense`,
  otherFarmingExpenses: `/other-farming-expense`,
  farmingNonArmLength: `/non-arm-length-transaction`,
  otherFarmingDeduction: `/other-farming-deduction`,
  quotaAdditionDisposition: `/quota-addition-disposition`,
  inventoryAdjustment: `/inventory-adjustment`,
  farmingReconciliationForm: `/farming-reconciliation`,
  agriStabilityInvestIntro: `/agristability-farming-intro`,
  agriStabilityInvestIncome: `/agristability-farming-income`,
  agriStabilityInvestExpenses: `/agristability-farming-expense`,
  agriStabilityOtherDeductions: `/agristability-other-deduction`,
  investmentExpenseData: `/investment-expense-data`,
  investmentExpensesIntro: `/investment-expense-intro`,
  interestExpenses: `/interest-expense`,
  carryingCharges: `/carrying-charge`,
  taxOnSplitIncomeData: `/tax-on-split-income-data`,
  taxOnSplitIncomeIntro: `/tax-on-split-income-intro`,
  taxOnSplitIncome: `/tax-on-split-income`,
  taxAdjustedIncome: `/adjusted-income`,
  rentalData: `/rental-data`,
  rentalPropertyIntro: `/rental-property-intro`,
  rentalIncome: `/rental-income`,
  rentalExpenses: `/rental-expense`,
  rentalPartnerDetailsStatement: `/partner-details-statement`,
  employmentExpensesData: `/employment-expense-data`,
  employementExpensesIntro: `/employment-expense-intro`,
  employmentExpensesProfile: `/employment-expense-profile`,
  getDataConfig: `/config`,
  t2200sEmploymentExpense: `/t2200s-employment-expense`,
  gstHstRebate: `/gst-hst-rebate`,
  employmentRelatedDriving: `/employment-related-driving`,
  otherEmploymentExpenses: `/other-employment-expenses`,
  workSpaceHomeExpense: `/work-space-home-expense`,
  rrspData: `/rrsp-profile-data`,
  rrspDeductionLimit: `/rrsp-deduction-limit`,
  rrspProfile: `/rrsp-profile`,
  rrspContribution: `/rrsp-contribution`,
  foreignRetirementPlanProfile: `/foreign-retirement-plan-profile`,
  contributionTemporaryAssignment: `/contribution-temporary-assignment`,
  contributionComputerCanada: `/contribution-computer-canada`,
  contributionForeignEmployer: `/contribution-foreign-employer`,
  unusedRrspDeductionLimit: `/unused-rrsp-prpp-contribution`,
  saskatchewanPensionPlan: `/saskatchewan-pension-plan`,
  pooledRegisteredPensionPlan: `/pooled-registered-pension-plan`,
  homeBuyerPlanProfile: `/home-buyer-plan-profile`,
  homeBuyerPlan: `/home-buyer-plan`,
  additionalHomeBuyerPlan: `/additional-home-buyer-plan`,
  lifelongLearningPlan: `/lifelong-learning-plan`,
  lifelongLearningProfile: `/lifelong-learning-profile`,
  additionalLlpWithdrawal: `/additional-llp-withdrawal`,
  transferRrspPrpp: `/transfer-rrsp-prpp`,
  refundUnusedRrspPrpp: `/refund-unused-rrsp-prpp`,
  rrspPrppCarryForward: `/rrsp-prpp-carryforward`,
  amateurAthleteTrust: `/amateur-athlete-trust-income`,
  registeredPensionPlan: `/registered-pension-plan-deduction`,
  rrspCalculator: `/rrsp-calculator`,
  paymentProfileData: `/payment-profile-data`,
  paymentProfile: `/payment-profile`,
  donationProfile: `/donation-profile`,
  charitableDonationCarriedForward: `/charitable-donation-carried-forward`,
  charitableDonation: `/charitable-donation`,
  usDonationReceipt: `/us-donation-receipt`,
  unitedState: `/united-states-donation`,
  sharesDonation: `/shares-donation`,
  capitalDonation: `/capital-donation`,
  culturalEcologicalGift: `/cultural-ecological-gift`,
  otherDonation: `/other-donations`,
  maxiMizingCharitableDonation: `/maximizing-charitable-donation`,
  donationClaimedCarriedForward: `/donation-claimed-carried-forward`,
  firstTimeHomeBuyer: `/first-time-home-buyer`,
  repaymentFederalCovid: `/repayment-federal-covid`,
  unionProfessionalMember: `/union-professional-member`,
  digitalNewsSubscription: `/digital-news-subscription-tax-credit`,
  politicalContribution: `/political-contribution`,
  foreignTaxCredits: `/foreign-tax-credits`,
  paidTaxInstalment: `/paid-tax-instalment`,
  movingProfile: `/moving-profile`,
  farDidYouMove: `/how-far-did-you-move`,
  movingProfileCarriedForward: `/moving-profile-carried-forward`,
  movingProfileData: `/moving-profile-data`,
  reasonForMoving: `/reason-for-moving`,
  saleOfYourOldHome: `/sale-of-your-old-home`,
  allowableMovingExpense: `/allowable-moving-expense`,
  newHomeExpense: `/new-home-expense`,
  eligibleIncomeAtNewLocation: `/eligible-income-at-new-location`,
  detailOfTheMove: `/details-of-the-move`,
  homeAccessibilityExpense: `/home-accessibility-expense`,
  disabilitySupportPaymentData: `/disability-support-payment-data`,
  disabilitySupportPayment: `/disability-support-payment`,
  disabilityAmount: `/disability-amount`,
  medicalExpenseData: `/medical-expense-data`,
  medicalProfile: `/your-medical-profile`,
  medicalExpense: `/medical-expense`,
  medicalExpenseReceipt: `/medical-expense-receipt`,
  privateMedicalPlan: `/private-medical-plan`,
  medicalExpenseClaim: `/medical-expense-claim`,
  studentData: `/student-data`,
  studentProfile: `/student-profile`,
  taxBreakGoingSchool: `/tax-breaks-going-school`,
  unusedTuitionEducation: `/unused-tuition-education`,
  studentLoanInterestProfile: `/student-loan-interest-profile`,
  studentLoanInterest: `/student-loan-interest`,
  researchGrantExpense: `/research-grant-expense`,
  eligibleReceiveCanadaTraining: `/eligible-receive-canada-training`,
  totalCreditReceiving: `/total-credit-receiving`,
  otherDeductionData: `/other-deduction-data`,
  eligibleEducatorTaxCredit: `/eligible-educator-tax-credit`,
  northernResidentDeduction: `/northern-resident-deduction`,
  additionalResidencyAmount: `/additional-residency-amount`,
  northernResidentDeductionTrips: `/northern-resident-deduction-trip`,
  volunteerFireFighterRescue: `/volunteer-firefighter-rescue-service`,
  otherDeduct: `/other-deduction`,
  additionalDeduction: `/additional-deduction`,
  additionalTaxAccumulatedResp: `/additional-tax-accumulated-resp`,
  ontarioProvincialData: `/ontario-provincial-data`,
  ontarioProvinceProfile: `/ontario-province-profile`,
  homeownerPropertyTaxGrant: `/homeowner-property-tax-grant`,
  homeSafetyTaxCredit: `/home-safety-tax-credit`,
  addressOfProperty: `/address-of-property`,
  applyForOntarioTrilliumBenefit: `/apply-for-ontario-trillium-benefit`,
  ontarioSelfEmploymentTaxCredit: `/ontario-self-employment-tax-credit`,
  cooperativeEducationTaxCredit: `/cooperative-education-tax-credit`,
  ontarioOpportunitiesFund: `/ontario-opportunities-fund`,
  climateActionIncentive: `/climate-action-incentive`,
  ontarioTrilliumBenefit: `/ontario-trillium-benefit`,
  lossesProfile: `/losses-profile`,
  allowableBusinessInvestmentLoss: `/allowable-business-investment-loss`,
  nonCapitalLossesCarryForward: `/non-capital-loss-carry-forward`,
  nonCapitalLossesBeingClaimed: `/non-capital-being-claimed`,
  paymentRelatedPrincipal: `/payment-related-principal-residence`,
  restrictedFarmingLossCarry: `/restricted-farming-loss-carry-forward`,
  restrictedFarmingLossClaimed: `/restricted-farming-loss-being-claimed`,
  farmingFishingLossCarryForward: `/farming-fishing-loss-carry-forward`,
  farmingFishingLossCarryClaimed: `/farming-fishing-loss-being-claimed`,
  personalPropertyLossCarryForward: `/personal-property-loss-carry-forward`,
  listedPersonalPropertyLoss: `/lpp-losses-being-claimed`,
  limitedPartnershipLoss: `/limited-partnership-loss`,
  netCapitalLossCarryForward: `/net-capital-loss-carry-forward`,
  netCapitalLossClaimedForward: `/net-capital-loss-being-claimed`,
  nonCapitalLossCarrybacks: `/non-capital-loss-carry-back`,
  farmingFishingLossCarrybacks: `/farming-fishing-loss-carry-back`,
  netCapitalLossCarrybacks: `/net-capital-loss-carry-back`,
  lppLossCarrybacks: `/lpp-loss-carry-back`,
  restrictedFarmLossCarrybacks: `/restricted-farm-loss-carry-back`,
  lossesProfileSummary: `/losses-profile-data`,
  albertaTaxCreditProfile: `/alberta-tax-credit-profile`,
  stockSavingsPlanTaxCredit: `/stock-savings-plan-tax-credit`,
  albertaProvincialData: `/alberta-provincial-data`,
  investorTaxCredit: `/investor-tax-credit`,
  britishColumbiaTaxCredit: `/british-columbia-tax-credit`,
  britishColumbiaProvincialData: `/british-columbia-provincial-data`,
  bcSalesTaxCredit: `/bc-sales-tax-credit`,
  homeRenovationTaxCredit: `/home-renovation-tax-credit`,
  trainingTaxCreditEmployer: `/training-tax-credit-employer`,
  trainingTaxCreditIndividual: `/training-tax-credit-individual`,
  trainingTaxCreditShipbuilding: `/training-tax-credit-shipbuilding`,
  miningExplorationTaxCredit: `/mining-exploration-tax-credit`,
  miningFlowThroughShareTaxCredit: `/mining-flow-through-share-tax-credit`,
  miningFlowThroughShareTaxCreditCarryback: `/mining-flow-through-share-tax-credit-carryback`,
  ventureCapital: `/venture-capital`,
  carryForwardCapitalGain: `/carry-forward-capital-gain`
};
